import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	newLabel: {
		id: 'issue-field-parent.changeboarding.new-label',
		defaultMessage: 'New',
		description: 'New indicator for the Parent field',
	},
	icon: {
		id: 'issue-field-parent.changeboarding.icon',
		defaultMessage: '{issueType} icon',
		description: 'Alt text explainer, i.e. Epic icon',
	},
	spotlightMessage: {
		id: 'issue-field-parent.changeboarding.spotlight-message',
		defaultMessage:
			'The <strong>Parent</strong> field has replaced <strong>Epic Link</strong> and <strong>Parent Link</strong>. It works in the same way.',
		description: 'Message explaing how the new Parent field is working and should be used',
	},
	spotligthLearnMore: {
		id: 'issue-field-parent.changeboarding.spotligth-learn-more',
		defaultMessage: 'Information on the parent field',
		description: 'Link to extra field information',
	},
	infoMessage: {
		id: 'issue-field-parent.changeboarding.info-message',
		defaultMessage: 'Your issue type hierarchy determines the issues you can select here.',
		description: 'Link to extra field information',
	},
	infoLearnMore: {
		id: 'issue-field-parent.changeboarding.info-learn-more',
		defaultMessage: 'Learn more about parent issues',
		description: 'Link to extra info about issue hierarchy',
	},
	ok: {
		id: 'issue-field-parent.changeboarding.ok',
		defaultMessage: 'OK',
		description: 'Ok button to dismiss the message',
	},
	parentFieldInfoTitle: {
		id: 'issue-field-parent.changeboarding.parent-field-info-title',
		defaultMessage: 'Parent field information',
		description: 'Title for the button with extra information',
	},
});
